import * as React from 'react';

import {Button, Select, Card, Icon} from 'antd';
import html2canvas from "html2canvas";

import styles from './BannerPreviewer.module.less'
import {proxyURL} from "../../api";


const {Option} = Select;

interface IOwnProps {
    output: string;
}

interface ICallbackProps {
    onSelectSizes?: (selectedSizes: string[]) => void;
    onScreenShotCompressed?: (value: string) => void;
}

export type IProps = IOwnProps & ICallbackProps;

interface IState {
    availableBannerSizes: Array<string>
    selectedSizes: Array<string>
    files: any[]
    downloading: {
        [key: string]: boolean
    }
}

class BannerPreviewer extends React.PureComponent<IProps, IState> {
    state: IState;

    constructor(props: IProps) {
        super(props);
        this.state = {
            availableBannerSizes: [
                "250x250",
                "300x250",
                "300x50",
                "320x280",
                "320x480",
                "320x50",
                "468x60",
                "480x320",
                "728x90",
                "768x1024",
                "1024x768",
            ],
            selectedSizes: ["250x250", "300x250", "320x480", "320x50", "728x90"],
            files: [],
            downloading: {}
        }
    }

    componentDidMount(): void {
        if (this.props.onSelectSizes) {
            this.props.onSelectSizes(this.state.selectedSizes)
        }
    }

    onDrop = (files: any) => {
        this.setState({files})
    };

    downloadAll = () => {
        this.state.selectedSizes.forEach(size => {
            this.takeScreenShot(size)
        })
    }

    takeScreenShot = (size: string) => {
        console.log(size)
        let iframe: HTMLIFrameElement | null = document.querySelector(`#i${size}`);
        if (iframe != null && iframe.contentWindow != null) {
            this.setState(prev => {
                return {
                    downloading: {
                        ...prev.downloading,
                        [size]: true
                    }
                }
            })

            html2canvas(iframe.contentWindow.document.body, {
                proxy: proxyURL, allowTaint: true, imageTimeout: 0, onclone: function (doc) {
                    return
                    /*
                    if (doc && doc.querySelector) {
                        let con: HTMLIFrameElement | null = doc.querySelector(`#con${size}`)
                        if (con != null) {
                            con.style.transform = 'none'
                        }
                    }

                     */
                }
            }).then(canvas => {

                let dataUrl = canvas.toDataURL();

                let link = document.createElement('a');
                link.href = dataUrl;
                link.download = `${size}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                /*
                let compressed = LZString.compress(dataUrl)
                this.setState(prev => {
                    return {
                        screenShot: {
                            ...prev.screenShot,
                            [size]: compressed
                        }
                    }
                })
                if (this.props.onScreenShotCompressed) {
                    this.props.onScreenShotCompressed(compressed);
                }
                 */
            }).finally(() => {
                this.setState(prev => {
                    return {
                        downloading: {
                            ...prev.downloading,
                            [size]: false
                        }
                    }
                })
            });
        }
    };

    onSelectSizes = (value: any) => {
        const selectSizes = value.sort((a: string, b: string) => {
            let [widthA, heightA] = a.split("x");
            let [widthB, heightB] = b.split("x");
            if (+widthA > +widthB) {
                return 1
            }
            if (+widthA < +widthB) {
                return -1
            }
            if (+heightA > +heightB) {
                return 1
            }
            if (+heightA < +heightB) {
                return -1
            }
            return 0
        })
        this.setState({
            selectedSizes: selectSizes
        })
        if (this.props.onSelectSizes) {
            this.props.onSelectSizes(selectSizes)
        }
    };

    selectAll = () => {
        this.setState({
            selectedSizes: this.state.availableBannerSizes
        })
        if (this.props.onSelectSizes) {
            this.props.onSelectSizes(this.state.availableBannerSizes)
        }
    }

    deselectAll = () => {
        this.setState({
            selectedSizes: []
        })
        if (this.props.onSelectSizes) {
            this.props.onSelectSizes([])
        }
    }


    render() {
        // console.log("BannerPreviewer render........")
        return (
            <React.Fragment>
                <Button className={styles.actionButton} onClick={this.selectAll}>Select All</Button>
                <Button className={styles.actionButton} onClick={this.deselectAll}>Deselect All</Button>
                <div className={styles.rootContainer}>

                    <Select
                        size="default"
                        mode="multiple"
                        placeholder="Select banner sizes"
                        value={this.state.selectedSizes}
                        onChange={this.onSelectSizes}
                    >
                        {
                            this.state.availableBannerSizes.map((size: string) => {
                                return (
                                    <Option key={size} value={size}>{size}</Option>
                                )
                            })
                        }
                    </Select>
                    <Button onClick={this.downloadAll} icon={"download"}>Download All Screenshot</Button>
                    <div className={styles.outContainer}>
                        <div className={styles.iframeOuterContainer}>
                            {
                                this.state.selectedSizes.map((size: string) => {
                                    let [width, height] = size.split("x");
                                    let downloading = (this.state.downloading[size] && this.state.downloading[size]) ? "loading" : "download"
                                    let title = <span>{size} <Button onClick={() => { this.takeScreenShot(size) }} icon={downloading}/></span>
                                    return (
                                        <Card className={styles.bannerPreviewerBox} key={size} title={title}>
                                            <div className={styles.iframeContainer}>
                                                <div id={`con${size}`} className={styles.iframeContainerDiv}>
                                                    <iframe
                                                        id={`i${size}`}
                                                        className={styles.iframe}
                                                        srcDoc={this.props.output}
                                                        width={width}
                                                        height={height}
                                                    >
                                                    </iframe>
                                                </div>
                                            </div>
                                        </Card>
                                    )
                                })
                            }
                        </div>
                    </div>
                    {/*<Button onClick={this.takeScreenShot}>Take ScreenShot</Button>*/}
                    {/*<img*/}
                    {/*    crossOrigin="anonymous"*/}
                    {/*    width={200}*/}
                    {/*    src={LZString.decompress(this.props.bannerTemplate.screenShot)}*/}
                    {/*/>*/}
                </div>
            </React.Fragment>
        )
    }
}

export default BannerPreviewer;


